// extracted by mini-css-extract-plugin
module.exports = {"signUpButton":"SignedOut_signUpButton__aI929","mainMessage":"SignedOut_mainMessage__xUXOE","loginMessage":"SignedOut_loginMessage__Zbpnx"};